import { render, staticRenderFns } from "./OrderConfirmation.vue?vue&type=template&id=64b5de64&scoped=true&lang=pug"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"
import style0 from "./OrderConfirmation.vue?vue&type=style&index=0&id=64b5de64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b5de64",
  null
  
)

export default component.exports